
  import { css } from 'lit';
  export const styles = css`:host{background:var(--background);color:var(--text-color);border-bottom:.0625rem solid var(--border-color);box-shadow:var(--elevation)}::slotted(igc-icon){color:var(--idle-icon-color)}::slotted(igc-icon:hover){color:var(--hover-icon-color)}`;
  